export { default } from '@/components/models/travel/PricingBlock/PricingBlockInfo/PricingBlockInfo'
